(function () {
  const root = document.querySelector('[data-package-picker]');
  if (!root) return;

  const handle = root.dataset.packageHandle;
  const config = (window.GRAVITY_PACKAGES || {})[handle];
  if (!config) {
    root.hidden = true;
    return;
  }

  root.hidden = false;

  const qvRoot = document.querySelector('[data-pkg-quickview]');

  function filterOptions() {
    return window.GRAVITY_FILTER_OPTIONS || { colors: [], textures: [], swatchFor: function () { return ''; } };
  }

  const els = {
    title: root.querySelector('[data-picker-title]'),
    lead: root.querySelector('[data-picker-lead]'),
    steps: root.querySelectorAll('[data-picker-steps] li'),
    progress: root.querySelector('[data-picker-progress]'),
    slots: root.querySelector('[data-picker-slots]'),
    slotIndex: root.querySelector('[data-slot-index]'),
    slotTotal: root.querySelector('[data-slot-total]'),
    slotLabel: root.querySelector('[data-slot-label]'),
    slotDims: root.querySelector('[data-slot-dims]'),
    slotCallout: root.querySelector('[data-slot-callout]'),
    search: root.querySelector('[data-picker-search]'),
    filters: root.querySelector('[data-picker-filters]'),
    filterSizeRow: root.querySelector('[data-picker-filter-row="size"]'),
    filterColorRow: root.querySelector('[data-picker-filter-row="color"]'),
    filterTexRow: root.querySelector('[data-picker-filter-row="tex"]'),
    filterCount: root.querySelector('[data-picker-filter-count]'),
    filterClear: root.querySelector('[data-picker-filter-clear]'),
    loading: root.querySelector('[data-picker-loading]'),
    loadingStatus: root.querySelector('[data-picker-loading-status]'),
    loadingBar: root.querySelector('[data-picker-loading-bar]'),
    gridWrap: root.querySelector('[data-picker-grid-wrap]'),
    empty: root.querySelector('[data-picker-empty]'),
    grid: root.querySelector('[data-picker-grid]'),
    track: root.querySelector('[data-picker-track]'),
    panelPick: root.querySelector('[data-picker-panel="pick"]'),
    panelReview: root.querySelector('[data-picker-panel="review"]'),
    review: root.querySelector('[data-picker-review]'),
    summary: root.querySelector('[data-picker-summary]'),
    back: root.querySelector('[data-picker-back]'),
    next: root.querySelector('[data-picker-next]'),
    fine: root.querySelector('[data-picker-fine]'),
    backTop: root.querySelector('[data-picker-back-top]'),
  };

  const qvEls = qvRoot
    ? {
        root: qvRoot,
        img: qvRoot.querySelector('[data-qv-img]'),
        code: qvRoot.querySelector('[data-qv-code]'),
        title: qvRoot.querySelector('[data-qv-title]'),
        size: qvRoot.querySelector('[data-qv-size]'),
        counter: qvRoot.querySelector('[data-qv-counter]'),
        thumbs: qvRoot.querySelector('[data-qv-thumbs]'),
        select: qvRoot.querySelector('[data-qv-select]'),
        prev: qvRoot.querySelector('[data-qv-prev]'),
        next: qvRoot.querySelector('[data-qv-next]'),
      }
    : null;

  const allSlots = (config.slots || []).slice();
  if (config.freeXs) {
    allSlots.push({
      size: 'XS',
      label: 'Free XS backdrop (bonus)',
      dims: '1.2 × 2.4m',
      bonus: true,
      freeXs: true,
    });
  }

  const state = {
    step: 'pick',
    slotIndex: 0,
    selections: allSlots.map(function () {
      return null;
    }),
    catalog: [],
    catalogReady: false,
    search: '',
    color: 'all',
    tex: 'all',
    qv: {
      handle: null,
      images: [],
      index: 0,
      loading: false,
    },
    animating: false,
    autoReviewTimer: null,
    filteredList: [],
    gridVisibleCount: 24,
    gridLoadingMore: false,
  };

  var SLIDE_MS = 600;
  var AUTO_REVIEW_DELAY_MS = 720;
  var GRID_PAGE_SIZE = 24;
  var gridObserver = null;
  var gridSentinel = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function variantIdForCart(id) {
    var n = Number(id);
    if (!Number.isFinite(n) || n < 1) return null;
    return n;
  }

  async function shopifyCartJson(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });
    var data = {};
    try {
      data = await res.json();
    } catch (parseErr) {
      data = {};
    }
    if (!res.ok) {
      var msg =
        data.description ||
        data.message ||
        (data.errors && String(data.errors)) ||
        'Request failed (' + res.status + ')';
      throw new Error(msg);
    }
    return data;
  }

  async function addCartLines(lines) {
    if (!lines.length) return;
    if (lines.length === 1) {
      await shopifyCartJson('/cart/add.js', lines[0]);
      return;
    }
    await shopifyCartJson('/cart/add.js', { items: lines });
  }

  async function clearCartForPackage() {
    var res = await fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      throw new Error('Could not prepare your bag for the studio package.');
    }
    return res.json();
  }

  async function prepareCartForPackageAdd() {
    var cart = null;
    if (window.GravityCart && window.GravityCart.fetchCartWithBundles) {
      cart = await window.GravityCart.fetchCartWithBundles();
    } else if (window.GravityPackageDiscount && window.GravityPackageDiscount.fetchCartState) {
      cart = await window.GravityPackageDiscount.fetchCartState();
    }
    if (!cart || !cart.items || !cart.items.length) return;

    var hasPackage =
      window.GravityPackageDiscount &&
      window.GravityPackageDiscount.hasAnyPackageLine &&
      window.GravityPackageDiscount.hasAnyPackageLine(cart);
    var message = hasPackage
      ? 'Replace the studio package already in your bag with this one?'
      : 'Adding a studio package replaces individual canvases in your bag. BOGO offers do not apply to packages — only package pricing. Continue?';

    if (!window.confirm(message)) {
      throw new Error('PACKAGE_ADD_CANCELLED');
    }

    await clearCartForPackage();
  }

  async function ensurePackagePricingApplied() {
    var guard = window.GravityPackageDiscount;
    if (!guard || typeof guard.reconcile !== 'function') return null;

    var cart = null;
    for (var attempt = 0; attempt < 4; attempt++) {
      if (attempt > 0) {
        await new Promise(function (resolve) {
          setTimeout(resolve, 300);
        });
      }
      if (typeof guard.fetchCartState === 'function') {
        cart = await guard.fetchCartState();
      } else if (window.GravityCart && window.GravityCart.fetchCart) {
        cart = await window.GravityCart.fetchCart();
      } else {
        break;
      }
      cart = await guard.reconcile(cart);
      if (
        guard.packagePricingApplied &&
        guard.packagePricingApplied(cart, handle)
      ) {
        return cart;
      }
      if (
        guard.findQualifyingHandle &&
        !guard.findQualifyingHandle(cart)
      ) {
        return cart;
      }
    }
    return cart;
  }

  /**
   * Path + query for Shopify /discount redirect (never include hash — # gets encoded into query).
   */
  function packageReturnPath() {
    var params = new URLSearchParams(window.location.search);
    params.delete('open_cart');
    params.set('open_cart', '1');
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function lineProperty(item, key) {
    var props = item && item.properties;
    if (!props) return '';
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        if (props[i] && props[i].name === key) return String(props[i].value || '');
      }
      return '';
    }
    return props[key] != null ? String(props[key]) : '';
  }

  async function finishAddToBag() {
    if (window.GravityCart && window.GravityCart.renderCart && window.GravityCart.openCartDrawer) {
      await window.GravityCart.renderCart();
      window.GravityCart.openCartDrawer();
      try {
        var url = packageReturnPath() + (window.location.hash || '');
        history.replaceState({}, '', url);
      } catch (e) {
        /* ignore */
      }
      return;
    }

    window.location.assign(packageReturnPath() + (window.location.hash || ''));
  }

  function selectionSubtotalCents() {
    return state.selections.reduce(function (sum, sel) {
      return sum + (sel && sel.priceCents ? sel.priceCents : 0);
    }, 0);
  }

  function getOption(product, name) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].name === name && opts[i].values && opts[i].values[0]) {
        return opts[i].values[0];
      }
    }
    return '';
  }

  function productSize(product) {
    var pt = (product.product_type || '').trim();
    if (pt) return pt;
    return getOption(product, 'Size') || '';
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function extractImages(product) {
    return (product.images || [])
      .map(function (img) {
        return typeof img === 'string' ? img : img.src;
      })
      .filter(Boolean);
  }

  function normalizeProduct(product) {
    var variant = firstAvailableVariant(product);
    if (!variant || !variant.available) return null;
    var titleParts = (product.title || '').split(' ');
    var images = extractImages(product);
    var variantId = variantIdForCart(variant.id);
    if (!variantId) return null;
    var price = parseFloat(variant.price) || 0;
    var colorRaw = getOption(product, 'Color') || '';
    var texRaw = getOption(product, 'Texture') || '';
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      code: titleParts[0] || '',
      size: productSize(product),
      color: colorRaw.toLowerCase(),
      tex: texRaw.replace(/ texture$/i, '').trim(),
      url: '/products/' + product.handle,
      image: images[0] || '',
      images: images,
      variantId: variantId,
      price: price,
      priceCents: Math.round(price * 100),
    };
  }

  async function ensureProductImages(product) {
    if (product.images && product.images.length > 1) return product.images;
    try {
      var res = await fetch('/products/' + product.handle + '.js');
      if (!res.ok) return product.images || [];
      var data = await res.json();
      var imgs = (data.images || []).filter(Boolean);
      if (imgs.length) product.images = imgs;
      return product.images || [];
    } catch (err) {
      return product.images || [];
    }
  }

  function setCatalogLoading(active) {
    if (els.gridWrap) {
      els.gridWrap.classList.toggle('is-catalog-loading', active);
      els.gridWrap.setAttribute('aria-busy', active ? 'true' : 'false');
    }
    if (els.loading) {
      els.loading.setAttribute('aria-hidden', active ? 'false' : 'true');
    }
    if (els.grid) {
      els.grid.setAttribute('aria-hidden', active ? 'true' : 'false');
    }
  }

  function setLoadingStatus(message) {
    if (els.loadingStatus) els.loadingStatus.textContent = message;
  }

  function setLoadingProgress(pct) {
    if (!els.loadingBar) return;
    var n = Math.max(0, Math.min(100, pct));
    els.loadingBar.style.width = n + '%';
  }

  async function fetchCatalog() {
    var products = [];
    var page = 1;
    var maxPages = 40;
    var catalogHandle =
      document.documentElement.dataset.catalogCollection || 'all-in-stock';
    var slot = currentSlot();
    var sizeLabel = slot && slot.size ? slot.size : 'your';

    setCatalogLoading(true);
    setLoadingProgress(8);
    setLoadingStatus('Connecting to the in-stock catalogue…');

    while (page <= maxPages) {
      setLoadingStatus(
        page === 1
          ? 'Loading hand-painted backdrops…'
          : 'Still loading — page ' + page + ' of the catalogue…'
      );
      setLoadingProgress(Math.min(12 + page * 18, 82));

      var res = await fetch(
        '/collections/' +
          encodeURIComponent(catalogHandle) +
          '/products.json?limit=250&page=' +
          page
      );
      if (!res.ok) break;
      var data = await res.json();
      if (!data.products || !data.products.length) break;
      products = products.concat(data.products);
      if (data.products.length < 250) break;
      page++;
    }

    setLoadingStatus('Matching ' + sizeLabel + ' sizes for your package slots…');
    setLoadingProgress(92);

    state.catalog = products
      .map(normalizeProduct)
      .filter(function (p) {
        return p && p.variantId;
      });
    state.catalogReady = true;

    var matchCount = state.catalog.filter(function (p) {
      return p.size === (slot && slot.size);
    }).length;

    setLoadingProgress(100);
    setLoadingStatus(
      matchCount
        ? 'Found ' + matchCount + ' ' + sizeLabel + ' backdrop' + (matchCount === 1 ? '' : 's') + ' — opening gallery…'
        : 'Gallery ready — pick your canvases below'
    );

    await new Promise(function (resolve) {
      setTimeout(resolve, prefersReducedMotion() ? 0 : 320);
    });

    setCatalogLoading(false);
    renderFilters();
    renderGrid();
  }

  function filterChip(label, val, key, sw, pressed, locked) {
    var swatch = sw
      ? '<span class="pkg-picker__chip-swatch" style="background:' + sw + '"></span>'
      : '';
    return (
      '<button type="button" class="pkg-picker__chip' +
      (locked ? ' is-locked' : '') +
      '" data-filter-key="' +
      esc(key) +
      '" data-filter-val="' +
      esc(val) +
      '" aria-pressed="' +
      (pressed ? 'true' : 'false') +
      '"' +
      (locked ? ' disabled aria-disabled="true"' : '') +
      '>' +
      swatch +
      esc(label) +
      '</button>'
    );
  }

  function resetSlotFilters() {
    state.color = 'all';
    state.tex = 'all';
    state.search = '';
    if (els.search) els.search.value = '';
  }

  function renderFilters() {
    if (!els.filters || !state.catalogReady) return;
    var slot = currentSlot();
    if (!slot) return;

    els.filters.hidden = false;

    if (els.filterSizeRow) {
      els.filterSizeRow.innerHTML =
        '<span class="pkg-picker__filter-label">Size</span>' +
        filterChip(slot.size, slot.size, 'size', '', true, true);
    }

    var fo = filterOptions();

    if (els.filterColorRow) {
      els.filterColorRow.innerHTML =
        '<span class="pkg-picker__filter-label">Colour</span>' +
        filterChip('All', 'all', 'color', '', state.color === 'all') +
        fo.colors
          .map(function (c) {
            return filterChip(c.label, c.key, 'color', fo.swatchFor(c.key), state.color === c.key);
          })
          .join('');
    }

    if (els.filterTexRow) {
      els.filterTexRow.innerHTML =
        '<span class="pkg-picker__filter-label">Texture</span>' +
        filterChip('All', 'all', 'tex', '', state.tex === 'all') +
        fo.textures
          .map(function (t) {
            return filterChip(t.label, t.key, 'tex', '', state.tex === t.key);
          })
          .join('');
    }

    root.querySelectorAll('[data-filter-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('is-locked')) return;
        var key = btn.getAttribute('data-filter-key');
        var val = btn.getAttribute('data-filter-val');
        if (key === 'color') state.color = val;
        if (key === 'tex') state.tex = val;
        renderFilters();
        renderGrid();
      });
    });
  }

  function updateFilterCount(matchCount, slotSize) {
    if (!els.filterCount) return;
    var suffix = matchCount === 1 ? ' backdrop' : ' backdrops';
    els.filterCount.textContent =
      matchCount +
      ' ' +
      slotSize +
      suffix +
      (state.color !== 'all' || state.tex !== 'all' || state.search ? ' match your filters' : ' in this slot');
  }

  function usedHandles() {
    return state.selections
      .filter(function (s) {
        return s;
      })
      .map(function (s) {
        return s.handle;
      });
  }

  function currentSlot() {
    return allSlots[state.slotIndex];
  }

  function isFreeSlot(slot) {
    return !!(slot && (slot.bonus || slot.freeXs));
  }

  function slotNumParts(i, slot) {
    var n = i + 1;
    if (isFreeSlot(slot)) {
      return {
        num: String(n),
        free: true,
      };
    }
    return { num: String(n), free: false };
  }

  function slotNumHtml(i, slot) {
    var parts = slotNumParts(i, slot);
    if (parts.free) {
      return (
        '<span class="pkg-picker__slot-pill-num">' +
        parts.num +
        '</span><span class="pkg-picker__slot-pill-num-free"> (FREE)</span>'
      );
    }
    return '<span class="pkg-picker__slot-pill-num">' + parts.num + '</span>';
  }

  function setSlotIndexDisplay(i, slot) {
    if (!els.slotIndex) return;
    var parts = slotNumParts(i, slot);
    if (parts.free) {
      els.slotIndex.innerHTML =
        parts.num + '<span class="pkg-picker__slot-index-free"> (FREE)</span>';
    } else {
      els.slotIndex.textContent = parts.num;
    }
  }

  function filledCount() {
    return state.selections.filter(Boolean).length;
  }

  function progressPct() {
    if (state.step === 'review') return 100;
    return Math.round((filledCount() / allSlots.length) * 85);
  }

  function updateProgress() {
    els.progress.style.width = progressPct() + '%';
    els.steps.forEach(function (step) {
      var key = step.getAttribute('data-step');
      step.classList.toggle('is-active', key === state.step);
      step.classList.toggle('is-done', key === 'pick' && state.step === 'review');
    });
  }

  function renderSlotPills() {
    els.slots.innerHTML = allSlots
      .map(function (slot, i) {
        var sel = state.selections[i];
        var active = state.step === 'pick' && i === state.slotIndex;
        var done = !!sel;
        var cls = 'pkg-picker__slot-pill';
        if (active) cls += ' is-active';
        if (done) cls += ' is-done';
        if (slot.bonus) cls += ' is-bonus';
        var thumb = sel && sel.image
          ? '<img src="' + esc(sel.image) + '" alt="">'
          : '<span class="pkg-picker__slot-pill-empty" aria-hidden="true"></span>';
        var status = active
          ? 'Selecting now'
          : done
            ? 'Selected'
            : 'Tap to fill';
        return (
          '<button type="button" class="' +
          cls +
          '" data-slot-pill="' +
          i +
          '">' +
          (active ? '<span class="pkg-picker__slot-pill-badge">Active</span>' : '') +
          slotNumHtml(i, slot) +
          '<span class="pkg-picker__slot-pill-visual">' +
          thumb +
          '</span>' +
          '<span class="pkg-picker__slot-pill-label">' +
          esc(slot.label) +
          '</span>' +
          '<span class="pkg-picker__slot-pill-status">' +
          status +
          '</span>' +
          '</button>'
        );
      })
      .join('');

    els.slots.querySelectorAll('[data-slot-pill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-slot-pill'), 10);
        if (state.step !== 'pick') return;
        state.slotIndex = idx;
        resetSlotFilters();
        updateSlotUI();
        renderFilters();
        renderGrid();
      });
    });
  }

  function setNextButtonLoading(loading) {
    if (!els.next) return;
    els.next.classList.toggle('is-loading', loading);
    els.next.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      els.next.disabled = true;
      els.next.textContent = 'Adding to bag…';
    }
  }

  function updateSlotUI() {
    var slot = currentSlot();
    if (!slot) return;
    if (els.slotTotal) els.slotTotal.textContent = String(allSlots.length);
    setSlotIndexDisplay(state.slotIndex, slot);
    els.slotLabel.textContent = slot.label;
    var dimsText = slot.dims + ' · ' + slot.size + ' size only';
    if (slot.bonus) dimsText += ' · included free';
    els.slotDims.textContent = dimsText;
    els.slotCallout.classList.toggle('is-bonus', !!slot.bonus);
    renderSlotPills();
    updateProgress();

    var canContinue = filledCount() === allSlots.length;
    els.next.disabled = state.step === 'pick' && !canContinue;
    els.next.textContent =
      state.step === 'pick'
        ? canContinue
          ? 'Review your package'
          : 'Pick ' + (allSlots.length - filledCount()) + ' more'
        : 'Add package to bag';
    els.back.hidden = state.step !== 'review';
  }

  function buildFilteredList() {
    var slot = currentSlot();
    if (!slot) return [];

    var fo = filterOptions();
    var taken = usedHandles();
    var q = state.search.toLowerCase();
    var list = state.catalog.filter(function (p) {
      if (p.size !== slot.size) return false;
      if (taken.indexOf(p.handle) !== -1) return false;
      if (
        fo.colorMatchesFilter
          ? !fo.colorMatchesFilter(p.color, state.color)
          : state.color !== 'all' && p.color !== state.color
      ) {
        return false;
      }
      if (state.tex !== 'all' && p.tex !== state.tex) return false;
      if (!q) return true;
      var hay = [p.code, p.title, p.size, p.color, p.tex].join(' ').toLowerCase();
      return hay.indexOf(q) !== -1;
    });

    list.sort(function (a, b) {
      return a.title.localeCompare(b.title);
    });

    return list;
  }

  function renderGridCard(p, idx) {
    var displayName = p.title.replace(/^\S+\s*/, '');
    return (
      '<article class="pkg-picker__card" data-handle="' +
      esc(p.handle) +
      '" style="--card-delay:' +
      Math.min(idx, 24) * 40 +
      'ms">' +
      '<div class="pkg-picker__card-visual">' +
      (p.image
        ? '<img src="' + esc(p.image) + '" alt="' + esc(displayName) + '" loading="lazy">'
        : '<div class="pkg-picker__card-ph"></div>') +
      '<button type="button" class="pkg-picker__qv-btn" data-qv-handle="' +
      esc(p.handle) +
      '">Quick view</button>' +
      '</div>' +
      '<div class="pkg-picker__card-body">' +
      '<span class="pkg-picker__card-code">' +
      esc(p.code) +
      '</span>' +
      '<span class="pkg-picker__card-name">' +
      esc(displayName) +
      '</span>' +
      '<button type="button" class="btn btn-primary pkg-picker__pick-btn" data-pick="' +
      esc(p.handle) +
      '">Select this backdrop</button>' +
      '</div>' +
      '</article>'
    );
  }

  function detachGridSentinel() {
    if (gridObserver && gridSentinel) {
      gridObserver.unobserve(gridSentinel);
    }
    if (gridSentinel && gridSentinel.parentNode) {
      gridSentinel.parentNode.removeChild(gridSentinel);
    }
    gridSentinel = null;
  }

  function ensureGridObserver() {
    if (gridObserver || typeof IntersectionObserver === 'undefined') return;
    gridObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadMoreGrid();
        });
      },
      { root: null, rootMargin: '280px 0px', threshold: 0 }
    );
  }

  function syncGridSentinel(hasMore) {
    detachGridSentinel();
    if (!hasMore || !els.gridWrap) return;

    ensureGridObserver();
    if (!gridObserver) return;

    gridSentinel = document.createElement('div');
    gridSentinel.className = 'pkg-picker__grid-sentinel';
    gridSentinel.setAttribute('data-picker-grid-sentinel', '');
    gridSentinel.setAttribute('aria-hidden', 'true');
    els.gridWrap.appendChild(gridSentinel);
    gridObserver.observe(gridSentinel);
  }

  function loadMoreGrid() {
    if (state.gridLoadingMore || state.step !== 'pick') return;
    if (state.gridVisibleCount >= state.filteredList.length) {
      detachGridSentinel();
      return;
    }

    state.gridLoadingMore = true;
    var prevCount = state.gridVisibleCount;
    state.gridVisibleCount = Math.min(
      state.gridVisibleCount + GRID_PAGE_SIZE,
      state.filteredList.length
    );
    renderGrid({ appendFrom: prevCount });
    state.gridLoadingMore = false;
  }

  function renderGrid(options) {
    options = options || {};
    if (!state.catalogReady) return;
    var slot = currentSlot();
    if (!slot || state.step !== 'pick') {
      detachGridSentinel();
      return;
    }

    var list = buildFilteredList();
    state.filteredList = list;

    if (!options.appendFrom && options.appendFrom !== 0) {
      state.gridVisibleCount = GRID_PAGE_SIZE;
    }

    state.gridVisibleCount = Math.min(state.gridVisibleCount, list.length);

    updateFilterCount(list.length, slot.size);
    els.empty.hidden = list.length > 0;

    var visible = list.slice(0, state.gridVisibleCount);
    var hasMore = state.gridVisibleCount < list.length;

    if (options.appendFrom != null) {
      var batch = list.slice(options.appendFrom, state.gridVisibleCount);
      if (batch.length) {
        els.grid.insertAdjacentHTML(
          'beforeend',
          batch
            .map(function (p, i) {
              return renderGridCard(p, options.appendFrom + i);
            })
            .join('')
        );
      }
    } else {
      els.grid.classList.remove('pkg-picker__grid--revealed');
      els.grid.innerHTML = visible
        .map(function (p, idx) {
          return renderGridCard(p, idx);
        })
        .join('');
      if (visible.length) {
        requestAnimationFrame(function () {
          els.grid.classList.add('pkg-picker__grid--revealed');
        });
      }
    }

    syncGridSentinel(hasMore);
  }

  function selectProduct(product) {
    var slot = currentSlot();
    state.selections[state.slotIndex] = {
      handle: product.handle,
      title: product.title,
      code: product.code,
      image: product.image,
      variantId: product.variantId,
      priceCents: product.priceCents,
      slotLabel: slot.label,
      size: product.size,
      bonus: !!slot.bonus,
    };

    els.slotCallout.classList.add('is-pop');
    setTimeout(function () {
      els.slotCallout.classList.remove('is-pop');
    }, 420);

    var nextEmpty = state.selections.findIndex(function (s, i) {
      return !s && i > state.slotIndex;
    });
    if (nextEmpty === -1) {
      nextEmpty = state.selections.findIndex(function (s) {
        return !s;
      });
    }
    if (nextEmpty !== -1) state.slotIndex = nextEmpty;

    resetSlotFilters();
    updateSlotUI();
    renderFilters();
    renderGrid();

    if (filledCount() === allSlots.length) {
      scheduleAutoReview();
    }
  }

  function clearAutoReview() {
    if (state.autoReviewTimer) {
      clearTimeout(state.autoReviewTimer);
      state.autoReviewTimer = null;
    }
  }

  function scheduleAutoReview() {
    clearAutoReview();
    state.autoReviewTimer = setTimeout(function () {
      state.autoReviewTimer = null;
      if (state.step !== 'pick' || filledCount() < allSlots.length || state.animating) return;
      goReview({ animated: true, auto: true });
    }, AUTO_REVIEW_DELAY_MS);
  }

  function renderQvSlide() {
    if (!qvEls || !state.qv.images.length) return;
    var imgs = state.qv.images;
    var idx = state.qv.index;
    var src = imgs[idx];
    qvEls.img.src = src;
    qvEls.img.alt = qvEls.title.textContent || '';
    qvEls.counter.textContent = idx + 1 + ' / ' + imgs.length;
    qvEls.prev.disabled = idx <= 0;
    qvEls.next.disabled = idx >= imgs.length - 1;

    qvEls.thumbs.innerHTML = imgs
      .map(function (url, i) {
        return (
          '<button type="button" class="pkg-quickview__thumb' +
          (i === idx ? ' is-active' : '') +
          '" data-qv-thumb="' +
          i +
          '"><img src="' +
          esc(url) +
          '" alt=""></button>'
        );
      })
      .join('');
  }

  function closeQuickView() {
    if (!qvEls) return;
    state.qv.handle = null;
    state.qv.images = [];
    state.qv.index = 0;
    qvEls.root.hidden = true;
    qvEls.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pkg-quickview-open');
  }

  async function openQuickView(handle) {
    if (!qvEls) return;
    var product = state.catalog.find(function (p) {
      return p.handle === handle;
    });
    if (!product) return;

    state.qv.handle = handle;
    state.qv.index = 0;
    state.qv.loading = true;

    qvEls.code.textContent = product.code;
    qvEls.title.textContent = product.title.replace(/^\S+\s*/, '');
    qvEls.size.textContent = product.size + ' · Hand-painted original';
    qvEls.img.src = product.image || '';
    qvEls.counter.textContent = 'Loading…';
    qvEls.thumbs.innerHTML = '';
    qvEls.prev.disabled = true;
    qvEls.next.disabled = true;

    qvEls.root.hidden = false;
    qvEls.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pkg-quickview-open');

    var images = await ensureProductImages(product);
    state.qv.images = images.length ? images : product.image ? [product.image] : [];
    state.qv.loading = false;
    renderQvSlide();
  }

  function renderReview() {
    els.review.innerHTML = state.selections
      .map(function (sel, i) {
        if (!sel) return '';
        var slot = allSlots[i];
        return (
          '<li class="pkg-picker__review-item' +
          (slot.bonus ? ' is-bonus' : '') +
          '">' +
          (sel.image ? '<img src="' + esc(sel.image) + '" alt="">' : '') +
          '<div><strong>' +
          esc(slot.label) +
          '</strong><span>' +
          esc(sel.title) +
          '</span></div></li>'
        );
      })
      .join('');

    els.summary.innerHTML =
      '<p><strong>' +
      esc(config.name) +
      '</strong> · ' +
      esc(config.priceLabel) +
      ' package</p>' +
      '<p>' +
      esc(config.savingsLabel || '') +
      ' · Free worldwide shipping on packages · Free XS on qualifying purchases</p>';

    if (state.step === 'review') syncStageHeight();
  }

  async function submitPackage() {
    setNextButtonLoading(true);

    var lines = [];
    var missingVariant = false;
    state.selections.forEach(function (sel, i) {
      if (!sel) return;
      var vid = variantIdForCart(sel.variantId);
      if (!vid) {
        missingVariant = true;
        return;
      }
      lines.push({
        id: vid,
        quantity: 1,
        properties: {
          _package: config.name,
          _package_handle: handle,
          _slot: String(i + 1) + '/' + String(allSlots.length),
          _slot_label: sel.slotLabel,
          _code: sel.code,
        },
      });
    });

    if (missingVariant || lines.length !== allSlots.length) {
      setNextButtonLoading(false);
      updateSlotUI();
      alert('Some canvases could not be added. Please re-select each slot and try again.');
      return;
    }

    if (window.GravityCart && window.GravityCart.fetchCartWithBundles) {
      try {
        var cartForGuard = await window.GravityCart.fetchCartWithBundles();
        var inBagIds = window.GravityCart.collectCartVariantIds(cartForGuard);
        for (var gi = 0; gi < state.selections.length; gi++) {
          var guardSel = state.selections[gi];
          if (!guardSel) continue;
          var guardVid = String(variantIdForCart(guardSel.variantId));
          if (inBagIds.has(guardVid)) {
            setNextButtonLoading(false);
            alert(
              guardSel.code +
                ' is already in your bag. Remove it before adding this package.'
            );
            return;
          }
        }
      } catch (guardErr) {
        console.warn('[PackagePicker] cart duplicate guard failed', guardErr);
      }
    }

    var subtotalCents = selectionSubtotalCents();
    var targetCents = config.packagePriceCents || 0;
    var discountCents = Math.max(0, subtotalCents - targetCents);

    var noteLines = ['Studio package: ' + config.name + ' (' + config.priceLabel + ')'];
    state.selections.forEach(function (sel, i) {
      if (sel) noteLines.push(i + 1 + '. ' + sel.slotLabel + ': ' + sel.code + ' — ' + sel.title);
    });
    if (targetCents > 0) {
      noteLines.push(
        'Canvas subtotal: €' +
          (subtotalCents / 100).toFixed(2) +
          ' → Package price: €' +
          (targetCents / 100).toFixed(2)
      );
    }

    try {
      await prepareCartForPackageAdd();
      await addCartLines(lines);

      await shopifyCartJson('/cart/update.js', {
        attributes: {
          'Studio package': config.name,
          'Package handle': handle,
          'Package price': config.priceLabel,
          'Package canvas subtotal': '€' + (subtotalCents / 100).toFixed(2),
          'Package discount needed': '€' + (discountCents / 100).toFixed(2),
        },
        note: noteLines.join('\n'),
      });

      var pricedCart = await ensurePackagePricingApplied();
      if (
        pricedCart &&
        window.GravityPackageDiscount &&
        window.GravityPackageDiscount.packagePricingApplied &&
        !window.GravityPackageDiscount.packagePricingApplied(pricedCart, handle) &&
        config.discountCode
      ) {
        console.warn(
          '[PackagePicker] Automatic package discount failed for',
          config.name
        );
      }

      await finishAddToBag();
    } catch (err) {
      if (err && err.message === 'PACKAGE_ADD_CANCELLED') {
        return;
      }
      alert(
        'Could not add to bag: ' +
          (err && err.message ? err.message : 'Unknown error') +
          '. If this keeps happening, contact us with your package name.'
      );
    } finally {
      setNextButtonLoading(false);
      updateSlotUI();
    }
  }

  function applyReviewCopy() {
    els.title.textContent = 'Review your ' + config.name;
    els.lead.textContent =
      'Confirm your canvas choices — we apply package pricing at checkout.';
    els.panelPick.setAttribute('aria-hidden', 'true');
    els.panelReview.setAttribute('aria-hidden', 'false');
    updateSlotUI();
    updateProgress();
  }

  function applyPickCopy() {
    els.title.textContent = 'Choose your canvases';
    els.lead.textContent =
      allSlots.length +
      ' hand-painted originals — use Quick view to see every photo, then Select to claim each slot.';
    els.panelPick.setAttribute('aria-hidden', 'false');
    els.panelReview.setAttribute('aria-hidden', 'true');
    updateSlotUI();
    renderGrid();
  }

  function scrollPickerIntoView() {
    var target = root.querySelector('[data-picker-stage]') || root;
    target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  }

  function goReview(options) {
    options = options || {};
    if (state.step === 'review' || state.animating) return;

    clearAutoReview();
    renderReview();
    state.step = 'review';
    root.dataset.step = 'review';

    var animated = options.animated !== false && !prefersReducedMotion();

    if (!animated) {
      root.classList.add('is-review');
      root.classList.remove('is-sliding');
      applyReviewCopy();
      syncStageHeight();
      if (options.auto) scrollPickerIntoView();
      return;
    }

    state.animating = true;
    root.classList.add('is-sliding');
    applyReviewCopy();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-review');
      });
    });

    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      state.animating = false;
      root.classList.remove('is-sliding');
      if (els.track) els.track.removeEventListener('transitionend', onEnd);
      syncStageHeight();
      if (options.auto) scrollPickerIntoView();
    };

    function onEnd(e) {
      if (e.propertyName === 'transform') finish();
    }

    if (els.track) {
      els.track.addEventListener('transitionend', onEnd);
      setTimeout(finish, SLIDE_MS + 80);
    } else {
      finish();
    }

    syncStageHeight();
  }

  function syncStageHeight() {
    var stage = root.querySelector('[data-picker-stage]');
    if (!stage) return;
    if (state.step === 'review' && els.panelReview) {
      stage.style.height = els.panelReview.offsetHeight + 'px';
    } else {
      stage.style.height = '';
    }
  }

  function goPick(options) {
    options = options || {};
    if (state.step === 'pick' || state.animating) return;

    clearAutoReview();
    var animated = options.animated !== false && !prefersReducedMotion();

    if (!animated) {
      state.step = 'pick';
      root.dataset.step = 'pick';
      root.classList.remove('is-review', 'is-sliding');
      syncStageHeight();
      applyPickCopy();
      return;
    }

    state.animating = true;
    root.classList.add('is-sliding');
    root.classList.remove('is-review');
    syncStageHeight();
    els.title.textContent = 'Choose your canvases';
    els.lead.textContent =
      allSlots.length +
      ' hand-painted originals — use Quick view to see every photo, then Select to claim each slot.';

    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      state.animating = false;
      root.classList.remove('is-sliding');
      state.step = 'pick';
      root.dataset.step = 'pick';
      applyPickCopy();
      syncStageHeight();
      if (els.track) els.track.removeEventListener('transitionend', onEnd);
    };

    function onEnd(e) {
      if (e.propertyName === 'transform') finish();
    }

    if (els.track) {
      els.track.addEventListener('transitionend', onEnd);
      setTimeout(finish, SLIDE_MS + 80);
    } else {
      finish();
    }
  }

  if (els.grid) {
    els.grid.addEventListener('click', function (e) {
      var qvBtn = e.target.closest('[data-qv-handle]');
      if (qvBtn) {
        e.preventDefault();
        openQuickView(qvBtn.getAttribute('data-qv-handle'));
        return;
      }
      var pickBtn = e.target.closest('[data-pick]');
      if (pickBtn) {
        var h = pickBtn.getAttribute('data-pick');
        var product = state.catalog.find(function (p) {
          return p.handle === h;
        });
        if (product) selectProduct(product);
      }
    });
  }

  if (qvEls) {
    qvEls.root.querySelectorAll('[data-qv-close]').forEach(function (btn) {
      btn.addEventListener('click', closeQuickView);
    });

    qvEls.prev.addEventListener('click', function () {
      if (state.qv.index > 0) {
        state.qv.index--;
        renderQvSlide();
      }
    });

    qvEls.next.addEventListener('click', function () {
      if (state.qv.index < state.qv.images.length - 1) {
        state.qv.index++;
        renderQvSlide();
      }
    });

    qvEls.thumbs.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-qv-thumb]');
      if (!thumb) return;
      state.qv.index = parseInt(thumb.getAttribute('data-qv-thumb'), 10);
      renderQvSlide();
    });

    qvEls.select.addEventListener('click', function () {
      var product = state.catalog.find(function (p) {
        return p.handle === state.qv.handle;
      });
      if (product) {
        selectProduct(product);
        closeQuickView();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (qvEls.root.hidden) return;
      if (e.key === 'Escape') closeQuickView();
      if (e.key === 'ArrowLeft' && state.qv.index > 0) {
        state.qv.index--;
        renderQvSlide();
      }
      if (e.key === 'ArrowRight' && state.qv.index < state.qv.images.length - 1) {
        state.qv.index++;
        renderQvSlide();
      }
    });
  }

  if (els.search) {
    els.search.addEventListener(
      'input',
      function () {
        state.search = els.search.value.trim();
        renderGrid();
      },
      { passive: true }
    );
  }

  if (els.filterClear) {
    els.filterClear.addEventListener('click', function () {
      resetSlotFilters();
      renderFilters();
      renderGrid();
    });
  }

  els.back.addEventListener('click', function () {
    goPick({ animated: true });
  });

  els.next.addEventListener('click', function () {
    if (state.animating) return;
    if (state.step === 'pick') {
      if (filledCount() < allSlots.length) return;
      clearAutoReview();
      goReview({ animated: true });
      return;
    }
    submitPackage();
  });

  if (els.title) els.title.textContent = 'Build your ' + config.name;
  if (els.lead) {
    els.lead.textContent =
      allSlots.length + ' canvases — quick view, then select.';
  }

  root.dataset.step = 'pick';
  renderSlotPills();
  updateSlotUI();

  if (els.backTop) {
    var backTopThreshold = 360;
    function updateBackTop() {
      var show = window.scrollY > backTopThreshold;
      els.backTop.hidden = !show;
      els.backTop.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', updateBackTop, { passive: true });
    els.backTop.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    });
    updateBackTop();
  }

  fetchCatalog();
})();
